export default {
  // 地图关卡名称名称 默认场景 北京 园区
  中国: {
    '中国-数据中心': {
      id: '中国-数据中心',
      name: '中国-数据中心',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'shujuzhongxin',
        },
        {
          name: '北京数据中心',
          color: '#ffff',
          iconName: '北京数据中心2',
        },
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: '数据中心',
        jsonPath: './data/all/普通摄像头点位.json',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '中国-数据传输': {
      id: '中国-数据传输',
      name: '中国-数据传输',
      coordType: 0,
      coordTypeZ: 0,
      valueMax: 10,
      valueMin: 0,
      isShowBubble: false,
      bubbleRadiusMax: 300000,
      bubbleRadiusMin: 100000,
      bubbleSpeed: 50000,
      lineWidthMax: 15000,
      lineWidthMin: 15000,
      lineSpeed: 200000,
      curvature: 0.6,
      legends: [
        {
          name: 'default',
          type: 'ray', // default arrow dot
          bubbleColor: '#00ff00', // 117EEA
          lineColor: '#00ff00',
          labelColor: '#ffffffff',
          labelBackgroundColor: '#ffffffff',
        },
      ],
      data: [],
      layerConfig: {
        layerType: 'ODLineLayer',
        scatterType: '数据传输',
        startCoordZ: '20',
        targetCoordZ: '20',
        jsonPath: './data/LianDongZhiHui/事件救援-链路图1.json',
        isClick: false,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '中国-数据传输_气泡': {
      id: '中国-数据传输_气泡',
      name: '中国-数据传输_气泡',
      coordType: 0,
      coordTypeZ: 0,
      fillArea: 'none',
      speed: 50000,
      radiusMax: 300000,
      radiusMin: 100000,
      valueMax: 10,
      valueMin: 0,
      visible: true,
      legends: [
        {
          name: 'default',
          color: '#00ff00',
        },
      ],
      data: [],
      layerConfig: {
        layerType: 'bubbleLayer',
        scatterType: '数据传输_气泡',
        jsonPath: './data/LianDongZhiHui/事件救援-链路图1.json',
        isClick: false,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '中国-告警_数据传输': {
      id: '中国-告警_数据传输',
      name: '中国-告警_数据传输',
      coordType: 0,
      coordTypeZ: 0,
      valueMax: 10,
      valueMin: 0,
      isShowBubble: true,
      bubbleRadiusMax: 300000,
      bubbleRadiusMin: 100000,
      bubbleSpeed: 50000,
      lineWidthMax: 15000,
      lineWidthMin: 15000,
      lineSpeed: 200000,
      curvature: 0.6,
      legends: [
        {
          name: 'default',
          type: 'ray', // default arrow dot
          bubbleColor: '#ff0000',
          lineColor: '#FF0000',
          labelColor: '#ffffffff',
          labelBackgroundColor: '#ffffffff',
        },
      ],
      data: [],
      layerConfig: {
        layerType: 'ODLineLayer',
        scatterType: '告警_数据传输',
        startCoordZ: '20',
        targetCoordZ: '20',
        jsonPath: './data/LianDongZhiHui/事件救援-链路图1.json',
        isClick: false,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
  },
  北京: {
    '北京-数据中心': {
      id: '北京-数据中心',
      name: '北京-数据中心',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'shujuzhongxin',
        },
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: '数据中心',
        jsonPath: './data/all/普通摄像头点位.json',
        isClick: true,
        coordZ: 2000,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '北京-行政区标识': {
      id: '北京-行政区标识',
      name: '北京-行政区标识',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'shujuzhongxin',
        },
      ],
      layerConfig: {
        layerType1: 'difLandmarkLayer',
        scatterType: '行政区标识',
        isClick: true,
        coordZ: 5000,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '北京-数据传输': {
      id: '北京-数据传输',
      name: '北京-数据传输',
      coordType: 0,
      coordTypeZ: 0,
      valueMax: 10,
      valueMin: 0,
      isShowBubble: false,
      bubbleRadiusMax: 10000,
      bubbleRadiusMin: 5000,
      bubbleSpeed: 500,
      lineWidthMax: 800,
      lineWidthMin: 800,
      lineSpeed: 28000,
      curvature: 0.5,
      legends: [
        {
          name: 'default',
          type: 'ray', // default arrow dot
          bubbleColor: '#00ff00',
          lineColor: '#00ff00',
          labelColor: '#ffffffff',
          labelBackgroundColor: '#ffffffff',
        },
      ],
      data: [],
      layerConfig: {
        layerType: 'ODLineLayer',
        scatterType: '数据传输',
        startCoordZ: 1,
        targetCoordZ: 1,
        jsonPath: './data/LianDongZhiHui/事件救援-链路图1.json',
        isClick: false,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '北京-数据传输_气泡': {
      id: '北京-数据传输_气泡',
      name: '北京-数据传输_气泡',
      coordType: 0,
      coordTypeZ: 0,
      fillArea: 'none',
      speed: 500,
      radiusMax: 10000,
      radiusMin: 5000,
      valueMax: 10,
      valueMin: 0,
      visible: true,
      legends: [
        {
          name: 'default',
          color: '#00ff00',
        },
      ],
      data: [],
      layerConfig: {
        layerType: 'bubbleLayer',
        scatterType: '数据传输_气泡',
        jsonPath: './data/LianDongZhiHui/事件救援-链路图1.json',
        isClick: false,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '北京-告警_数据传输': {
      id: '北京-告警_数据传输',
      name: '北京-告警_数据传输',
      coordType: 0,
      coordTypeZ: 0,
      valueMax: 10,
      valueMin: 0,
      isShowBubble: true,
      bubbleRadiusMax: 10000,
      bubbleRadiusMin: 5000,
      bubbleSpeed: 500,
      lineWidthMax: 800,
      lineWidthMin: 800,
      lineSpeed: 28000,
      curvature: 0.5,
      legends: [
        {
          name: 'default',
          type: 'ray', // default arrow dot
          bubbleColor: '#ff2626',
          lineColor: '#ff0000',
          labelColor: '#ffffffff',
          labelBackgroundColor: '#ffffffff',
        },
      ],
      data: [],
      layerConfig: {
        layerType: 'ODLineLayer',
        scatterType: '告警_数据传输',
        startCoordZ: '20',
        targetCoordZ: '20',
        jsonPath: './data/LianDongZhiHui/事件救援-链路图1.json',
        isClick: false,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
  },
  园区: {
    '园区-安保人员': {
      id: '园区-安保人员',
      name: '园区-安保人员',
      trackStyle: 'style001',
      trackDuration: 1,
      trackWidth: 0.2,
      objLife: 500,
      duraiotn: 1,
      legends: [
        {
          name: 'default',
          trackColor: '#ff0000',
          iconName: 'anbaorenyuan',
        },
      ],
      layerConfig: {
        layerType: 'trailLayer',
        scatterType: '安保人员',
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-巡检人员': {
      id: '园区-巡检人员',
      name: '园区-巡检人员',
      trackStyle: 'style001',
      trackDuration: 1,
      trackWidth: 0.2,
      objLife: 500,
      duraiotn: 1,
      legends: [
        {
          name: 'default',
          trackColor: '#ff0000',
          iconName: 'xunjianrenyuan',
        },
      ],
      layerConfig: {
        layerType: 'trailLayer',
        scatterType: '巡检人员',
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-安保人员1': {
      id: '园区-安保人员1',
      name: '园区-安保人员1',
      trackStyle: 'style001',
      trackDuration: 1,
      trackWidth: 0.1,
      objLife: 500,
      duraiotn: 1,
      legends: [
        {
          name: 'default',
          trackColor: '#ff0000',
          iconName: 'anbaorenyuan',
        },
      ],
      layerConfig: {
        layerType: 'trailLayer',
        scatterType: '安保人员',
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-巡检人员1': {
      id: '园区-巡检人员1',
      name: '园区-巡检人员1',
      trackStyle: 'style001',
      trackDuration: 1,
      trackWidth: 0.1,
      objLife: 500,
      duraiotn: 1,
      legends: [
        {
          name: 'default',
          trackColor: '#ff0000',
          iconName: 'xunjianrenyuan',
        },
      ],
      layerConfig: {
        layerType: 'trailLayer',
        scatterType: '巡检人员',
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-固定摄像头': {
      id: '园区-固定摄像头',
      name: '园区-固定摄像头',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'shexiangtouguding',
        },
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: '固定摄像头', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-云台摄像头': {
      id: '园区-云台摄像头',
      name: '园区-云台摄像头',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'shexiangtouyuntai',
        },
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: '云台摄像头', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-空间使用': {
      id: '设备-空间使用',
      name: '设备-空间使用',
      layerConfig: {
        alpha: 1,
        legends: {
          空闲: {
            name: '空闲',
            color: '#00506A',
            alpha: '1',
          },
          推荐位置: {
            name: '推荐位置',
            color: '#1C5807', //#76D30C
            alpha: '1',
          },
          可以移动: {
            name: '可以移动',
            color: '#8A7900', //#FFDD03
            alpha: '1',
          },
          移动困难: {
            name: '移动困难',
            color: '#802000', //#FF7706
            alpha: '0.1',
          },
          不可移动: {
            name: '不可移动',
            color: '#00506A',
            alpha: '1',
          },
        },
        layerType: 'BoxLayer',
        scatterType: '空间使用', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-承重使用': {
      id: '设备-承重使用',
      name: '设备-承重使用',
      layerConfig: {
        layerType: 'BoxLayer',
        legends: {
          default: {
            name: 'default',
            color: '#6AC80D',
          },
          20: {
            name: '20',
            color: '#068A8A',
          },
          40: {
            name: '40',
            color: '#B5D500',
          },
          60: {
            name: '60',
            color: '#BF8200',
          },
          80: {
            name: '80',
            color: '#FF4600',
          },
        },
        scatterType: '承重使用', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-功耗使用': {
      id: '设备-功耗使用',
      name: '设备-功耗使用',
      legends: [
        {
          name: '高功耗',
          color: '#FF5A19',
        },
        {
          name: '一般功耗',
          color: '#FF9703',
        },
        {
          name: '常规功耗',
          color: '#04B3E5',
        },
        {
          name: '节能',
          color: '#23BC05',
        },
      ],
      layerConfig: {
        legends: {
          高功耗: {
            name: '高功耗',
            color: '#FF5A19',
          },
          一般功耗: {
            name: '一般功耗',
            color: '#FF9703',
          },
          常规功耗: {
            name: '常规功耗',
            color: '#04B3E5',
          },
          节能: {
            name: '节能',
            color: '#23BC05',
          },
        },
        layerType: 'BoxLayer',
        scatterType: '功耗使用', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-人脸识别摄像头': {
      id: '园区-人脸识别摄像头',
      name: '园区-人脸识别摄像头',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'shexiangtourenlianshibie',
        },
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: '人脸识别摄像头', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-门禁设备': {
      id: '园区-门禁设备',
      name: '园区-门禁设备',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'menjinshijian',
        },
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: '门禁设备', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-可燃气体探测器': {
      id: '园区-可燃气体探测器',
      name: '园区-可燃气体探测器',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'keranqititanceqi',
        },
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: '可燃气体探测器', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-消防烟感': {
      id: '园区-消防烟感',
      name: '园区-消防烟感',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'xiaofangyangan',
        },
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: '消防烟感', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-水表设备': {
      id: '园区-水表设备',
      name: '园区-水表设备',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'shuibiaoshebei',
        },
      ],
      layerConfig: {
        layerType: 'panel',
        scatterType: '水表设备', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-电表设备': {
      id: '园区-电表设备',
      name: '园区-电表设备',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'dianbiaoshebei',
        },
      ],
      layerConfig: {
        layerType: 'panel',
        scatterType: '电表设备', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-燃气表设备': {
      id: '园区-燃气表设备',
      name: '园区-燃气表设备',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'ranqibiaoshebei',
        },
      ],
      layerConfig: {
        layerType: 'panel',
        scatterType: '燃气表设备', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-空调': {
      id: '园区-空调',
      name: '园区-空调',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'kongtiao',
        },
      ],
      layerConfig: {
        layerType: 'panel',
        scatterType: '空调', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-环境监测设备': {
      id: '园区-环境监测设备',
      name: '园区-环境监测设备',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'huanjingjianceshebei',
        },
      ],
      layerConfig: {
        layerType: 'panel',
        scatterType: '环境监测设备', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-UPS': {
      id: '园区-UPS',
      name: '园区-UPS',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'UPS',
        },
      ],
      layerConfig: {
        layerType: 'panel',
        scatterType: 'UPS', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-配电柜': {
      id: '园区-配电柜',
      name: '园区-配电柜',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'PeiDianGui',
        },
      ],
      layerConfig: {
        layerType: 'panel',
        scatterType: '配电柜', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-告警_设备': {
      id: '园区-告警_设备',
      name: '园区-告警_设备',
      coordType: 0,
      coordTypeZ: 0,
      visible: true,
      legends: [
        {
          name: 'default',
          icon: 'gaojing',
          type: 'wave',
          color: '#ff0000',
          fillArea: 'type01',
          speed: 1.5,
          radius: 5,
        },
        {
          name: '紧急告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#ff0000',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1.5,
        },
        {
          name: '重要告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#FFA91A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1.5,
        },
        {
          name: '次要告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#DAF48A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1.5,
        },
        {
          name: '提示告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#DAF48A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1.5,
        },
      ],
      data: [],
      layerConfig: {
        layerType: 'eventLayer',
        scatterType: '设备告警',
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-告警_机柜': {
      id: '园区-告警_机柜',
      name: '园区-告警_机柜',
      coordType: 0,
      coordTypeZ: 0,
      visible: true,
      legends: [
        {
          name: 'default',
          icon: 'gaojing',
          type: 'wave',
          color: '#ff0000',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '紧急告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#ff0000',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '重要告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#FFA91A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '次要告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#DAF48A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '提示告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#DAF48A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
      ],
      data: [],
      layerConfig: {
        layerType: 'eventLayer',
        scatterType: '机柜告警',
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-告警_机柜告警实体状态': {
      id: '园区-告警_机柜告警实体状态',
      name: '园区-告警_机柜告警实体状态',
      visible: true,
      color: '#ff0000',
      layerConfig: {
        layerType: 'ModelLayer',
        scatterType: '机柜实体状态',
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-告警_能耗': {
      id: '园区-告警_能耗',
      name: '园区-告警_能耗',
      coordType: 0,
      coordTypeZ: 0,
      visible: true,
      legends: [
        {
          name: 'default',
          icon: 'gaojing',
          type: 'wave',
          color: '#ff0000',
          fillArea: 'type01',
          speed: 0.5,
          radius: 2,
        },
        {
          name: '紧急告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#ff0000',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '重要告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#FFA91A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '次要告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#DAF48A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '提示告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#DAF48A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
      ],
      data: [],
      layerConfig: {
        layerType: 'eventLayer',
        scatterType: '能耗告警',
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-告警_机器': {
      id: '园区-告警_机器',
      name: '园区-告警_机器',
      coordType: 0,
      coordTypeZ: 0,
      visible: true,
      legends: [
        {
          name: 'default',
          icon: 'gaojing',
          type: 'wave',
          color: '#ff0000',
          fillArea: 'type01',
          speed: 0.5,
          radius: 2,
        },
        {
          name: '紧急告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#ff0000',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '重要告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#FFA91A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '次要告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#DAF48A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '提示告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#DAF48A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
      ],
      data: [],
      layerConfig: {
        layerType: 'eventLayer',
        scatterType: '机器告警',
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-告警_端口': {
      id: '园区-告警_端口',
      name: '园区-告警_端口',
      coordType: 0,
      coordTypeZ: 0,
      visible: true,
      legends: [
        {
          name: 'default',
          icon: 'gaojing',
          type: 'wave',
          color: '#ff0000',
          fillArea: 'type01',
          speed: 0.5,
          radius: 2,
        },
        {
          name: '紧急告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#FF794D',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '重要告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#FFA91A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '次要告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#ECEC28',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
        {
          name: '提示告警',
          icon: 'gaojing',
          type: 'wave',
          color: '#DAF48A',
          fillArea: 'type01',
          speed: 0.5,
          radius: 1,
        },
      ],
      data: [],
      layerConfig: {
        layerType: 'eventLayer',
        scatterType: '端口告警',
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-温度云图': {
      id: '园区-温度云图',
      name: '园区-温度云图',
      coordType: 0,
      coordTypeZ: 0,
      coordZ: 8.5,
      type: 'default',
      alpha: 0.3,
      colorMax: '#FF6000',
      colorMin: '#009acf',
      valueMax: 10,
      valueMin: 0,
      radius: 4,
      visible: true,
      pointDataId: '',
      data: [],
      layerConfig: {
        layerType: 'heatMapLayer',
        scatterType: '温度云图',
        jsonPath: '',
        isClick: false,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-告警事件分布': {
      id: '园区-告警事件分布',
      name: '园区-告警事件分布',
      coordType: 0,
      coordTypeZ: 0,
      coordZ: 1.5,
      type: 'default',
      alpha: 0.3,
      colorMax: '#FF6000',
      colorMin: '#009acf',
      valueMax: 200,
      valueMin: 10,
      radius: 4,
      visible: true,
      pointDataId: '',
      data: [],
      layerConfig: {
        layerType: 'heatMapLayer',
        scatterType: '告警事件分布',
        jsonPath: '',
        isClick: false,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-告警_机器告警实体状态': {
      id: '园区-告警_机器告警实体状态',
      name: '园区-告警_机器告警实体状态',
      visible: true,
      color: '#ff0000',
      layerConfig: {
        layerType: 'ModelLayer',
        scatterType: '机器实体状态',
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-机柜点位': {
      id: '园区-机柜点位',
      name: '园区-机柜点位',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'jgd',
        },
      ],
      layerConfig: {
        showLabel: true,
        layerType: 'landmarkLayer',
        scatterType: '机柜点位', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
    '园区-JiGuiZuLayer': {
      id: '园区-JiGuiZuLayer',
      name: '园区-JiGuiZuLayer',
      legends: [
        {
          name: '不可移动',
          color: '#FF5C30',
          alpha: '0.5',
        },
        {
          name: '移动困难',
          color: '#FF7706',
          alpha: '0.5',
        },
        {
          name: '可以移动',
          color: '#FFDD03',
          alpha: '0.8',
        },
        {
          name: '推荐位置',
          color: '#76D30C',
          alpha: '0.8',
        },
        {
          name: '空闲',
          color: '#029ffd',
          alpha: '0',
        },
      ],
      layerConfig: {
        legends: {
          空闲: {
            name: '空闲',
            color: '#029ffd',
            alpha: '0',
          },
          推荐位置: {
            name: '推荐位置',
            color: '#00FF00', //#76D30C
            alpha: '0.8',
          },
          可以移动: {
            name: '可以移动',
            color: '#FFFF00', //#FFDD03
            alpha: '0.8',
          },
          移动困难: {
            name: '移动困难',
            color: '#FF0000', //#FF7706
            alpha: '0.5',
          },
          不可移动: {
            name: '不可移动',
            color: '#FF5C30',
            alpha: '0.5',
          },
        },
        layerType: 'JiGuiZuLayer',
        scatterType: '空间搜索机柜组', // 点位汇总中数据的名称
        jsonPath: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      },
    },
  },
  defaultLayers: {
    默认服务: {
      '默认服务-省份标识': {
        id: '默认场景-省份标识',
        name: '默认场景-省份标识',
        offset: 10,
        legends: [],
        layerConfig: {
          layerType: 'landmarkLayer',
          layerType1: 'difLandmarkLayer',
          scatterType: '省份标识',
          apiURL: '',
          coordZ: 1,
          isClick: false,
          status: 'none', // 显示状态 none show hide
          rawData: [], // 原始数据
          jsonData: {}, // 添加时候的数据
        },
      },
    },
    中国: {
      '默认服务-省份标识': {
        id: '默认场景-省份标识',
        name: '默认场景-省份标识',
        offset: 10,
        legends: [],
        layerConfig: {
          layerType: 'landmarkLayer',
          layerType1: 'difLandmarkLayer',
          scatterType: '省份标识',
          apiURL: '',
          coordZ: 1,
          isClick: false,
          status: 'none', // 显示状态 none show hide
          rawData: [], // 原始数据
          jsonData: {}, // 添加时候的数据
        },
      },
    },
    北京: {
      '北京-行政区标识': {
        id: '北京-行政区标识',
        name: '北京-行政区标识',
        offset: 10,
        legends: [],
        layerConfig: {
          layerType: 'landmarkLayer',
          layerType1: 'difLandmarkLayer',
          scatterType: '行政区标识',
          apiURL: '',
          isClick: false,
          status: 'none', // 显示状态 none show hide
          rawData: [], // 原始数据
          jsonData: {}, // 添加时候的数据
        },
      },
    },
  },
}
